import { auditLogUseCase } from "../../../../../usecases/logs";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";

export async function findInventoryBySku(sku, user) {
  const [inventory] = await findObjectUseCase().execute("inventory", {
    where: {
      sku: { $eq: sku },
      "storeId.id": { $eq: user?.storeAnalytic?.[0]?.id },
    },
    limit: 1,
  });

  return inventory;
}

export async function findComponentBySku(sku) {
  const [component] = await findObjectUseCase().execute("components", {
    where: {
      sku: { $eq: sku },
    },
    limit: 1,
  });

  return component;
}

export async function updateInventoryQuantity(inventoryId, newQuantity) {
  return await upsertUseCase().execute("inventory", {
    id: inventoryId,
    systemCount: newQuantity.toString(),
  });
}

export async function createAuditLog({
  user,
  message,
  collection,
  objectId,
  payload,
}) {
  return await auditLogUseCase().create({
    user: { id: user.id },
    logDate: new Date().toISOString(),
    message,
    collection,
    objectId,
    payload,
    store: { id: user.storeAnalytic[0]?.id },
  });
}

export async function findBackupComponent(sku, user) {
  const [backupComponent] = await findObjectUseCase().execute(
    "backup_pullouts",
    {
      where: {
        component: {
          sku: { $eq: sku },
        },
        "storeId.id": { $eq: user?.storeAnalytic?.[0]?.id },
      },
      include: ["all"],
    },
  );

  return backupComponent;
}
